import { useSwipeable } from 'react-swipeable';
import { useNavigate } from 'react-router-dom';

const Sharing = ({ language }: { language: string }) => {
  const navigate = useNavigate();

  const handlers = useSwipeable({
    onSwipedLeft: () => {
      navigate('/Kids');
    },
    onSwipedRight: () => {
      navigate('/main');
    },
    trackMouse: true,
    delta: 50,
    trackTouch: true
  });

  return (
    <div
      className="min-h-screen flex flex-col items-center p-6 bg-cover bg-center bg-fixed pt-[110px]"
      style={{ backgroundImage: "url('/image/Lona2.jpg')" }}
      {...handlers}
    >
      <p className="text-center text-xs text-green-950 mt-2">
        {language === "fr" ? "Glissez pour naviguer" : "Swipe to navigate"}
      </p>

      {/* Carte principale */}
      <div className="bg-white/80 backdrop-blur-md rounded-2xl max-w-2xl w-full shadow-xl mt-8 p-8 text-center">

        {/* Titre */}
        <h1 className="text-3xl font-light tracking-[0.3em] text-gray-800">
          {language === "fr" ? "À PARTAGER" : "SHARING"}
        </h1>

        {/* Nom du plat */}
        <h2 className="text-xl italic mt-4 text-gray-700">
          Méli-Mélo
        </h2>

        {/* Description */}
        <p className="text-gray-600 mt-4 leading-relaxed text-sm">
          {language === "fr"
            ? "Plateau de déjeuner oriental avec 2 œufs au plat, labné, tomate, concombre, olives, piment vert, piment rouge au feta, pain au zaatar (Manich), charcuterie (bastourma, pastrami), huile d’olive."
            : "Oriental breakfast platter with 2 fried eggs, labneh, tomato, cucumber, olives, green pepper, red pepper with feta, zaatar bread (Manich), charcuterie (basturma, pastrami), olive oil."}
        </p>

        {/* Prix */}
        <div className="mt-6">
          <span className="text-2xl font-semibold text-green-950">
            {language === "fr" ? "46$" : "$46"}
          </span>
        </div>

      </div>
    </div>
  );
};

export default Sharing;